import React from "react";
import Lottie from "lottie-react";
import loadingData from "../196-material-wave-loading.json";
import { Box } from "@mui/material/";

const defaultOptions = {
  loop: true,
  autoplay: true,
  animationData: loadingData.default,
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const LoadingScreen = () => {
  return (
    <Box
      sx={{
        marginTop: 8,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      {/* <Lottie options={defaultOptions} height={200} width={200} /> */}
      <Lottie
        animationData={loadingData}
        loop={true}
        style={{ height: "200px", width: "200px" }}
      />
    </Box>
  );
};

export default LoadingScreen;
